import { useQueryClient } from '@tanstack/react-query';
import { meQueryKey } from './auth';
import {
  accountsKey,
  balancesKey,
  budgetsKey,
  categoriesKey,
  debtsKey,
  familyKey,
  goalsKey,
  limitsKey,
  peopleKey,
  payeesKey,
  ratesKey,
  recurringKey,
  reportsKey,
  transactionsKey,
} from './ledger';

/** After any ledger change: refetch everything that may show it (through the API, permission-checked). */
export function useInvalidateLedger() {
  const queryClient = useQueryClient();
  return async () => {
    await Promise.all(
      [
        accountsKey,
        balancesKey,
        categoriesKey,
        familyKey,
        ratesKey,
        transactionsKey,
        payeesKey,
        debtsKey,
        peopleKey,
        recurringKey,
        budgetsKey,
        limitsKey,
        goalsKey,
        reportsKey,
        meQueryKey,
      ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
    );
  };
}
